import {
  ChangeDetectionStrategy,
  Component,
  input,
  model,
} from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule, MatSelectionListChange } from '@angular/material/list';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { RouterModule } from '@angular/router';
import { ISelectListOption } from '@lassi/webapp-shared';

@Component({
  selector: 'lib-multi-select-list',
  imports: [
    RouterModule,
    MatDividerModule,
    MatListModule,
    MatIconModule,
    MatSlideToggleModule,
    MatCheckboxModule,
  ],
  template: ` <mat-selection-list
    [multiple]="true"
    (selectionChange)="onSelectionChange($event)"
  >
    @for (result of options(); track result.id) {
      <mat-list-option
        [lines]="lines()"
        [value]="result"
        class="result-checkbox-container"
        [selected]="isSelected(result)"
      >
        <span class="checkbox-label mat-label-medium">{{ result.label }}</span>
      </mat-list-option>
    } @empty {
      <div>No result found.</div>
    }
  </mat-selection-list>`,
  styles: `
    @use '@angular/material' as mat;
    .result-checkbox-container {
      @include mat.list-overrides(
        (
          list-item-three-line-container-height: 3.5rem,
        )
      );
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultiSelectListComponent {
  options = input.required<ISelectListOption[]>();
  selectedOptions = model<ISelectListOption[]>([]);
  // max 3 lines according to Angular Material docs
  lines = input(1);

  isSelected(result: ISelectListOption): boolean {
    return this.selectedOptions().some((r) => r.id === result.id);
  }

  onSelectionChange(event: MatSelectionListChange): void {
    const selectedResults = event.source.selectedOptions.selected.map(
      (option) => option.value,
    );
    this.selectedOptions.set(selectedResults);
  }
}
